import Vue from "vue";
import { LOCAL, ROOT_FLAG } from "@/store/mutations";
import { DEFAULT_SOUND_TRACKS_MAXIMUM } from "@/constants";

const { TRACK_SOUND, UNTRACK_SOUND } = LOCAL;

export default {
	namespaced: true,
	state: {
		tracks: {},
	},
	getters: {
		trackCount: (state) => (id) => state.tracks[id] || 0,
		playLimitExceeded: (state, getters, rootState, rootGetters) => (sound) => {
			const config = rootGetters["sound/getConfig"](sound);
			const limit = config.limit ? config.max : DEFAULT_SOUND_TRACKS_MAXIMUM;

			return getters.trackCount(sound.id) >= limit;
		},
	},
	actions: {
		play({ dispatch, commit, getters }, sound) {
			if (!getters.playLimitExceeded(sound)) {
				dispatch("sound/play", {
					...sound,
					events: {
						play: () => commit(TRACK_SOUND, sound),
						end: () => commit(UNTRACK_SOUND, sound),
					},
				}, ROOT_FLAG);
			}
		},
	},
	mutations: {
		[TRACK_SOUND](state, sound) {
			const trackCount = state.tracks[sound.id] || 0;
			Vue.set(state.tracks, sound.id, trackCount + 1);
		},
		[UNTRACK_SOUND](state, sound) {
			const trackCount = state.tracks[sound.id];
			Vue.set(state.tracks, sound.id, trackCount - 1);
		},
	},
};
